import React from 'react';
import Accordion from "@atoms/accordion";
import {isEmpty} from "@helpers/helpers";

const FaqsWidget = ({faqs}) => {

    if (!isEmpty(faqs) && faqs.length) {
        return (
            <div>
                <p className=""><strong className="h2">سوالات متداول</strong></p>

                <div className="accordion mt-16 px-24 px-lg-32 rounded-8 border border-gray200">
                    {
                        faqs.map((faq, key) =>
                            <Accordion
                                itemKey={faq.id}
                                title={faq.caption}
                                content={faq.content}
                            />
                        )
                    }
                </div>
            </div>
        );
    }

    return '';
};

export default FaqsWidget;
